import {
  IFormSchemaV2,
  InputElementUnion,
  InputElementState,
  ITextInputElement,
  ITextAreaElement,
  IFileInputElement,
  IDateInputElement,
  IYearMonthInputElement,
  IPostalCodeInputElement,
  INumberInputElement,
  IFormulaResultElement,
  ICheckboxesElement,
  IRadioButtonsElement,
  ISelectElement,
} from "@graffer-inc/form-schema";
import { TextInputEditor } from "./editors/text-input-editor/text-input-editor";
import { TextAreaEditor } from "./editors/text-area-editor/text-area-editor";
import { CommonPropertiesEditor } from "./editors/common-properties-editor";
import { FileInputEditor } from "./editors/file-input-editor";
import { NumberInputEditor } from "./editors/number-input-editor/number-input-editor";
import { DateInputEditor } from "./editors/date-input-editor/date-input-editor";
import { YearMonthInputEditor } from "./editors/year-month-input-editor/year-month-input-editor";
import { PostalCodeInputEditor } from "./editors/postal-code-editor/postal-code-editor";
import { FormulaResultEditor } from "./editors/formula-result-editor/formula-result-editor";
import { SelectableEditor } from "./editors/selectable-editor/selectable-editor";

interface InputElementEditorProps {
  element: InputElementUnion;
  currentRawSchema: IFormSchemaV2;
  onElementUpdate: (arg: InputElementUnion) => void;
}

export const ElementEditorView: React.FC<InputElementEditorProps> = ({
  element,
  currentRawSchema,
  onElementUpdate,
}) => {
  return (
    <>
      {new InputElementState(element.inputType).matchType({
        text: (
          <TextInputEditor
            element={element as ITextInputElement}
            onElementUpdate={onElementUpdate}
          />
        ),
        text_area: (
          <TextAreaEditor
            element={element as ITextAreaElement}
            onElementUpdate={onElementUpdate}
          />
        ),
        number: (
          <NumberInputEditor
            element={element as INumberInputElement}
            onElementUpdate={onElementUpdate}
          />
        ),
        tel: (
          <CommonPropertiesEditor
            element={element}
            onElementUpdate={onElementUpdate}
          />
        ),
        date: (
          <DateInputEditor
            element={element as IDateInputElement}
            onElementUpdate={onElementUpdate}
          />
        ),
        date_range: (
          <CommonPropertiesEditor
            element={element}
            onElementUpdate={onElementUpdate}
          />
        ),
        time: (
          <CommonPropertiesEditor
            element={element}
            onElementUpdate={onElementUpdate}
          />
        ),
        datetime: (
          <CommonPropertiesEditor
            element={element}
            onElementUpdate={onElementUpdate}
          />
        ),
        time_range: (
          <CommonPropertiesEditor
            element={element}
            onElementUpdate={onElementUpdate}
          />
        ),
        datetime_range: (
          <CommonPropertiesEditor
            element={element}
            onElementUpdate={onElementUpdate}
          />
        ),
        year_month: (
          <YearMonthInputEditor
            element={element as IYearMonthInputElement}
            onElementUpdate={onElementUpdate}
          />
        ),
        email: (
          <CommonPropertiesEditor
            element={element}
            onElementUpdate={onElementUpdate}
          />
        ),
        checkboxes: (
          <SelectableEditor
            element={element as ICheckboxesElement}
            onElementUpdate={onElementUpdate}
          />
        ),
        radio_buttons: (
          <SelectableEditor
            element={element as IRadioButtonsElement}
            onElementUpdate={onElementUpdate}
          />
        ),
        select: (
          <SelectableEditor
            element={element as ISelectElement}
            onElementUpdate={onElementUpdate}
          />
        ),
        file: (
          <FileInputEditor
            element={element as IFileInputElement}
            onElementUpdate={onElementUpdate}
          />
        ),
        my_number: (
          <CommonPropertiesEditor
            element={element}
            onElementUpdate={onElementUpdate}
          />
        ),
        formula_result: (
          <FormulaResultEditor
            element={element as IFormulaResultElement}
            onElementUpdate={onElementUpdate}
          />
        ),
        postal_code: (
          <PostalCodeInputEditor
            element={element as IPostalCodeInputElement}
            sections={currentRawSchema.root}
            onElementUpdate={onElementUpdate}
          />
        ),
      })}
    </>
  );
};
